export default __webpack_public_path__ + "static/media/AppointmentSchedulingIcon.068b1704.svg";